export default {"src":"/_next/static/media/mail.d39e0638.svg","height":14,"width":17,"blurWidth":0,"blurHeight":0};